export default "__VITE_ASSET__5d6e8423__"